
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('newspaper-fold')]),_c('path',{attrs:{"d":"M23.25,6V20.25a2.25,2.25,0,0,1-4.5,0V3a1.5,1.5,0,0,0-1.5-1.5h-15A1.5,1.5,0,0,0,.75,3V20.25A2.25,2.25,0,0,0,3,22.5H21","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('line',{attrs:{"x1":"4.5","y1":"15","x2":"15","y2":"15","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('line',{attrs:{"x1":"4.5","y1":"18","x2":"10.5","y2":"18","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('rect',{attrs:{"x":"4.5","y":"5.25","width":"10.5","height":"6","rx":"0.75","ry":"0.75","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])
          )
        }
      }
    